import { render, staticRenderFns } from "./facturased.vue?vue&type=template&id=a6d7f16a&scoped=true"
import script from "./facturased.vue?vue&type=script&lang=js"
export * from "./facturased.vue?vue&type=script&lang=js"
import style0 from "./facturased.vue?vue&type=style&index=0&id=a6d7f16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d7f16a",
  null
  
)

export default component.exports